/**
 * Waar de webshop en het beheer draaien: **één domein** (LARAVEL.md B1, definitief).
 * Webshop op beautybewust.nl, beheer op beautybewust.nl/be, API op beautybewust.nl/api/v1.
 * Geen apart beheer- of api-subdomein: dan zouden CORS, cookies over subdomeinen en een
 * tweede build nodig zijn, zonder dat het iets oplevert voor één salon.
 *
 * De helpers hieronder blijven, zodat links tussen shop en beheer op één plek staan.
 */

/** Pad waarop het beheer draait. */
export const ADMIN_BASE = '/be'

/** Titel van elk beheerscherm. Hier en niet in admin/, zodat App.tsx hem al zet vóór het beheer laadt. */
export const ADMIN_TITLE = 'Beheer | Beauty Bewust'

/** Adres van een webshoppagina, gezien vanuit het beheer (zelfde domein = relatief). */
export const shopHref = (path = '/') => path

/** Adres van een pagina in het beheer, gezien vanuit de webshop. */
export const adminHref = (path = '') => `${ADMIN_BASE}${path}`
